import React, { PureComponent } from 'react'
import Link from 'next/link'
import Router from 'next/router'

import IconCaretDown from 'Images/SVG/CaretDown.svg'
import {
  WithLocation,
  LOCATION_TYPES,
  DirectoryLinkAs,
  DirectoryLinkHref,
} from 'utils/DirectoryParser'
import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import {
  Dropdown,
  DropButton,
  DropdownButtonContainer,
  DropdownContent,
  DropDownContentContainer,
  AnchorsContainer,
  DropdownFilterInput,
  LocationContainerDiv,
  LocationDropdownAnchor,
  DropdownCenteredContent,
  StyledDropdownAnchorContainer,
} from 'components/Directories/SearchFacetsContainer/Styled'

class LocationDropdown extends PureComponent {
  state = {
    showLocationDropdown: false,
    filteredLocations: this.props.locations,
  }

  dropdownRef = React.createRef()
  inputRef = React.createRef()

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
    Router.events.on('routeChangeStart', () => {
      this.setState({ showLocationDropdown: false })
    })
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    const { locations } = this.props
    if (
      this.dropdownRef &&
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      // Hide dropdown and reset list
      this.setState({ showLocationDropdown: false, filteredLocations: locations })
    } else if (
      this.inputRef &&
      this.inputRef.current &&
      this.inputRef.current.contains(event.target)
    ) {
      this.setState({ showLocationDropdown: true })
    } else {
      this.setState((prevState) => ({
        showLocationDropdown: !prevState.showLocationDropdown,
        filteredLocations: locations,
      }))
    }
  }

  filterList = (event) => {
    const { locations } = this.props
    let updatedList = locations
    updatedList = updatedList.filter((location) => {
      if (
        location &&
        location.name &&
        event.target &&
        event.target.value &&
        location.name.toLowerCase().search(event.target.value.toLowerCase()) !== -1
      ) {
        return location
      }
    })
    if (updatedList.length === 0) {
      updatedList = [locations[0]] // First element is always USA & Canada, All Provinces/States or All cities
    }
    this.setState({ filteredLocations: updatedList })
  }

  buildLocation = (directoryLinkLocationInformation, location) => {
    switch (directoryLinkLocationInformation.type) {
      case LOCATION_TYPES.NEIGHBORHOODS:
        return {
          ...directoryLinkLocationInformation,
          neighborhood: location.slug,
        }
      case LOCATION_TYPES.CITIES:
        return {
          ...directoryLinkLocationInformation,
          city: location.slug,
        }
      case LOCATION_TYPES.STATES:
        return {
          ...directoryLinkLocationInformation,
          state: location.slug,
        }
      case LOCATION_TYPES.COUNTRIES:
        return {
          ...directoryLinkLocationInformation,
          country: location.slug,
        }
      default:
    }
  }

  render() {
    const {
      selectedLocation,
      showSearchInput,
      directoryLinkInformation,
      directoryLinkLocationInformation,
    } = this.props
    const { showLocationDropdown, filteredLocations } = this.state

    const Anchors =
      filteredLocations &&
      filteredLocations.length > 0 &&
      filteredLocations.map((location, i) => {
        const buildLocation = this.buildLocation(directoryLinkLocationInformation, location)
        const newDirectoryLinkInformation = WithLocation(directoryLinkInformation, buildLocation)
        const as = DirectoryLinkAs(newDirectoryLinkInformation)
        const href = DirectoryLinkHref(newDirectoryLinkInformation)
        return (
          <Link scroll={false} href={href} as={as} key={i}>
            <StyledDropdownAnchorContainer>
              <LocationDropdownAnchor>{location.name}</LocationDropdownAnchor>
            </StyledDropdownAnchorContainer>
          </Link>
        )
      })
    if (!filteredLocations || filteredLocations.length <= 0) return null
    return (
      <LocationContainerDiv minWidth='220px' ref={this.dropdownRef}>
        <DropdownCenteredContent>
          <div>
            <Dropdown minWidth='180px'>
              <DropdownButtonContainer>
                <DropButton>{selectedLocation || filteredLocations[0].name}</DropButton>
              </DropdownButtonContainer>
              <DropdownContent showDropdown={showLocationDropdown}>
                <DropDownContentContainer ref={this.inputRef}>
                  {showSearchInput && (
                    <DropdownFilterInput type='text' onChange={this.filterList} />
                  )}
                  <AnchorsContainer>{Anchors}</AnchorsContainer>
                </DropDownContentContainer>
              </DropdownContent>
            </Dropdown>
          </div>
        </DropdownCenteredContent>
        <GenericLazyLoadImage
          src={IconCaretDown}
          alt='Down Button'
          width='16px'
          height='18px'
          mt='8px'
          mr='8px'
        />
      </LocationContainerDiv>
    )
  }
}

export default LocationDropdown
